import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/service/auth.service';
import { initializeApp } from 'firebase/app';
import { FBConfig } from 'src/environments/environment';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { ConfirmcodePage } from 'src/app/confirmcode/confirmcode.page';
import { WsAPiService } from 'src/app/ws-api.service';
import { LoadingService } from 'src/app/loading.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit {

  public name: string = "";
  public phonenumber: string = "";
  public username: string = "";
  public password: string = "";
  public repeatpassword: String = "";
  public hide: string;
  public uuid: string;
  fake = 'a7b5f065-61a9-4f4f-919b-c88c033f848e';
  public inputName: string = "";
  public inputUsername: string = "";
  public verifyer: RecaptchaVerifier;
  public auth: any
  public human: boolean = false;
  app = initializeApp(FBConfig);
  showPassword2 = false;
  showPassword3 = false;
  toggleShow2() {
    this.showPassword2 = !this.showPassword2;
  }
  toggleShow3() {
    this.showPassword3 = !this.showPassword3;
  }

  constructor(public ws: WsAPiService,
    public modalCtrl:ModalController,
    public loadingservice: LoadingService,
    private authService: AuthService) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    setTimeout(() => {
      this.getAuthOTP();
    }, 100);
  }

  signup() {

    // console.log(this.human);

    let x = this.phonenumber;

    if (!this.phonenumber || !this.password || !this.repeatpassword) {
      this.loadingservice.onAlert('ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ !');
      return;
    }

    if (this.password != this.repeatpassword) {
      this.loadingservice.onAlert('ລະຫັດທີ່ປ້ອນບໍ່ຕົງກັນ !');
      return;
    }

    if (this.human == false) {
      this.loadingservice.onAlert('ກະລຸນຢືນຢັນຕົວຕົນກ່ອນ !');
      return;
    }

    if ((x.charAt(0) == '2' && x.charAt(1) != '0') || x.charAt(0) == '5' || x.charAt(0) == '7' || x.charAt(0) == '6'
      || x.charAt(0) == '9') {
      // this.action = 3
      this.send_code();
    } else {
      this.loadingservice.onAlert('ເບີໂທບໍ່ຖືກຕ້ອງ !');
    }
  }
  async getAuthOTP() {
    try {

      this.loadingservice.onLoading('', 'ກະລຸນາລໍຖ້າ...')
      this.auth = getAuth(this.app);
      this.auth.languageCode = 'lo';
      this.verifyer = new RecaptchaVerifier('recaptcha',
        {
          'size': 'normal',
          'callback': (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            // console.log(response);
            this.human = true;
          }
        },
        this.auth);
      this.verifyer.render().then(r => {
        this.loadingservice.onDismiss();
        // console.log(r);

      }).catch(e => {
        console.log(e);
        this.loadingservice.onAlert('ກະລຸນາກວດສອບສັນຍານອິນເຕີເນັດຂອງທ່ານ ແລ້ວລອງໃໝ່ອີກຄັ້ງ');
        this.loadingservice.onDismiss();
        this.dismiss();
      })
    } catch (error) {
      console.error(error);
      this.loadingservice.onAlert('ເກີດຂໍ້ຜິດພາດບາງຢ່າງ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ');
      this.dismiss();
    }
  }
  async comfrim(phonenumber: string): Promise<any> {

    const modal = await this.modalCtrl.create({
      component: ConfirmcodePage,
      // cssClass: 'my-custom-class',
      componentProps: {
        'phonenumber': phonenumber,
      }
    });
    await modal.present();

    return new Promise((resolve, reject) => {

      modal.onWillDismiss().then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    });
  }
  send_code() {
    let that = this

    // console.log(this.auth + ".." + this.phonenumber + ".." + this.verifyer);

    signInWithPhoneNumber(this.auth, "+85620" + this.phonenumber, this.verifyer)
      .then(async (confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        // window.confirmationResult = confirmationResult;
        // console.log('s', confirmationResult);

        // const code: string = (this.OTP.first + this.OTP.second + this.OTP.third + this.OTP.forth + this.OTP.fifth + this.OTP.sixth).trim();


        // console.log(code);

        const code = await this.comfrim("+85620" + this.phonenumber)
        // console.log(code.data.code);
        if (!code.data.code) {
          // console.log("not");

          this.human = false;
          return;
        }


        // console.log("pass");


        confirmationResult.confirm(code.data.code).then(r => {
          r.user.getIdToken().then(res => {
            that.register(res);
            // console.log('res', res);

          }, errr => {
            console.log('err', errr);

          })

        }, err => {
          // this.presentAlert(' ລະຫັດຢັງຢືນຕົວຕົນບໍ່ຖືກຕ້ອງ ')
          console.log('err', err);
          this.loadingservice.onAlert('ລະຫັດຢັງຢືນຕົວຕົນບໍ່ຖືກຕ້ອງ');
          this.human = false;

        })


      }).catch((error) => {
        // Error; SMS not sent
        // ...too-many-requests
        console.log('erer', error);
        this.loadingservice.onAlert('Error '+JSON.stringify(error));
        // this.loadingservice.onAlert('ບໍ່ມີເບີໂທ +85620' + this.phonenumber + ' ' + 'ໃນລະບົບ');
        // this.get_signup();
        this.human = false;
      });
  }
  async register(googleToken: string) {

    const data = {
      name: "+85620" + this.phonenumber,
      phoneNumber: "+85620" + this.phonenumber,
      username: "+85620" + this.phonenumber,
      password: this.password,
      googleToken: googleToken
    }

    this.loadingservice.onLoading('', 'ກະລຸນາລໍຖ້າ...');


    this.authService.register(data).subscribe(async res => {
      // console.log(res);

      if (res.status == 1) {
        // console.log('register success!!!!!!!!!!!!!', res);
        this.loadingservice.onDismiss();

        this.loadingservice.onAlert('ການລົງທະບຽນສຳເລັດແລ້ວ');
        this.cancel()

      } else {
        // console.log('cant register', res);
        this.loadingservice.onDismiss();


        if(res.data.message=='username : +85620'+this.phonenumber+'  already exists!'){

          this.loadingservice.onAlert('ເບີໂທ +85620'+this.phonenumber+' ເຄີຍລົງທະບຽນແລ້ວ');

        }else{
          
          this.loadingservice.onAlert('ການລົງທະບຽນບໍ່ສຳເລັດ');
        }
      }
    }, async error => {
      console.log('errror', error);

      this.loadingservice.onAlert('ເກີດບັນຫາບາງຢ່າງ');

      this.loadingservice.onDismiss();

    })

  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode == 32 || (48 <= charCode && charCode <= 57)) { //backspace and number only
      return true;
    } else {
      return false;
    }
  }

  getcolor() {
    if (this.phonenumber.length < 8) {
      return 'medium'
    } else {
      return 'primary'
    }
  }

  cancel() {
    this.name = "";
    this.phonenumber = "";
    this.username = "";
    this.password = "";
    this.repeatpassword = ""
  }

  dismiss(){
    this.loadingservice.closeModal();
  }
}
